import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import UrzadRaportCennikowTable from "./components/UrzadRaportCennikowTable";
import UrzadRaportCennikowSearchbox from "./components/UrzadRaportCennikowSearchbox";
import UrzadService from "../UrzadService";
import LinieService from "../../konfiguracja/trasyConfig/linie/LinieService";
import {TopAlertUwaga} from "../../../componentsTopsa/alerty/TopAlerts";

export default class UrzadRaportCennikow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            raport: [],
            linie: [],
            czyByloSzukanie: false,
            setLoader: false,
            errorRaportu: false,
        };

    }

    componentDidMount() {
        this.pobierzLinie()
    }

    pobierzLinie() {
        LinieService.getLinie().then(function (response) {
            this.setState({linie: response.data.content})
        }.bind(this))
    }

    onClickSzukaj(linia, data, rodz) {
        this.setState({czyByloSzukanie: true, setLoader: true,errorRaportu:false})
        if(!Boolean(data)){
            this.setState({setLoader: false, errorRaportu:'Nie można pobrać raportu - nie wygenerowano cennika bazowego dla tej trasy'})
        }else{
            UrzadService.getRaportCennikowNew(linia.idLi, data, rodz).then(function (response) {
                this.setState({raport: response.data, setLoader: false})
            }.bind(this)).catch(err=>{
                this.setState({setLoader: false, errorRaportu:'Nie można pobrać raportu - cennik nie jest w pełni uzupełniony'})
            })
        }

    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'UrzadContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/urzad', text: 'Urząd'}, {addressUrl: '/urzad/raport-cenniki', text: 'Raport cenników'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <UrzadRaportCennikowSearchbox handleClickSzukaj={(linia, data, rodz) => this.onClickSzukaj(linia, data, rodz)}
                                                          linie={this.state.linie}/>
                        </Col>
                        <Col sm={12}>
                            {
                                Boolean(this.state.czyByloSzukanie) ?
                                    Boolean(this.state.setLoader) ?
                                        <div id={'simple-small-loader'}>
                                            <i className={'fa fa-spinner fa-spin'}></i>
                                        </div>
                                        :
                                        Boolean(this.state.errorRaportu)?
                                            <div style={{marginTop:'15px'}}>
                                            <TopAlertUwaga text={this.state.errorRaportu}/>
                                            </div>
                                            :
                                        <UrzadRaportCennikowTable data={this.state.raport}/>
                                    :
                                    ''
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raport_cennikow/UrzadRaportCennikow.js